import clsx from 'clsx';
import { motion, useAnimate, useInView } from 'framer-motion';
import Image from 'next/image';
import { useEffect } from 'react';

import useWindowDimensions from '@/hooks/useWindowDimensions';
import type { MediaT } from '@/utils/contentfulTypes';
import { getTailwindBreakpoints } from '@/utils/misc';

interface HeroSectionProps {
  data: MediaT;
}

export const HeroSection = ({ data }: HeroSectionProps) => {
  const { width } = useWindowDimensions();
  const isMobile = !!width && width < getTailwindBreakpoints('md');

  const [headerRef, animate] = useAnimate();
  const isInView = useInView(headerRef, {
    amount: 'all',
  });

  useEffect(() => {
    if (isInView) {
      animate(
        headerRef.current,
        { opacity: 1, translateY: 0 },
        {
          duration: 0.5,
          ease: 'easeOut',
        }
      );
    }
  }, [isInView]);

  return (
    <div className="relative flex h-[558px] bg-black p-6 pb-10 text-alter-bone md:h-[calc(80vh-110px)] md:p-20 md:pb-10 md:items-center">
      <Image
        src={isMobile ? data.imageMobile.url : data.imageDesktop.url}
        alt="Person working out with Alter system"
        fill
        className={clsx('object-cover')}
      />
      <div className="relative w-full width-1440 flex items-end md:items-center">
        <motion.h1
          ref={headerRef}
          className="modernGothicTrial-light text-[32px] leading-tight md:max-w-[25ch] md:text-[48px] md:relative"
          initial={{ opacity: 0, translateY: 60 }}
        >
          The first ever
          <br />
          integrated biometrics
          <br />
          and workout system
          {/* {data.headline} */}
        </motion.h1>
      </div>
    </div>
  );
};
